<template>
  <div>
    <!-- 提供給 消息(news)/買迷(memiaItem , memiaShop)/活動(activity) 分享的連結 -->
    <!-- 測試機 http://192.168.13.4:8092/gawbueVue/index.html#/shareToGawbue/{apName}/{targetId}/token/{token} -->
    <!-- 正式機 https://gawbue.lale.im/gawbueVue/index.html#/shareToGawbue/{apName}/{targetId}/token/{token} -->
    <SharePostTop></SharePostTop>
    <ShareContent></ShareContent>
    <EditPostBottom></EditPostBottom>
  </div>
</template>

<script>
import SharePostTop from '@/components/EditPost/SharePostTop';
import ShareContent from '@/components/EditPost/ShareContent';
import EditPostBottom from '@/components/EditPost/EditPostBottom';
export default {
  name: 'SharePost',
  components: {
    SharePostTop,
    ShareContent,
    EditPostBottom
  }
};
</script>

<style></style>
